import React from "react";
import Login from "./components/login/Login";
import "./App.css";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PrivateOutlet } from "./components/PrivateOutlet";
import Users from "./components/users/Users";
import Devices from "./components/devices/Devices";
import Measurementresults from "./components/measurementresults/Measurementresults";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PrivateOutlet />}>
          <Route path="/käyttäjätili" element={<Users />} />
          <Route path="/laitteet" element={<Devices />} />
          <Route path="/lämpötilat" element={<Measurementresults />} />
        </Route>
        <Route path="/login/:Id" element={<Login />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
